import type { ApproveRejectInput, ProxyApproveInput } from '@lms/shared'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

export function usePendingApprovals() {
  return useQuery({
    queryKey: ['pending-approvals'],
    queryFn: () => api.get('/api/training-approvals/pending'),
  })
}

export function useApproveEnrollment() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data?: ApproveRejectInput }) =>
      api.post(`/api/training-approvals/${id}/approve`, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['pending-approvals'] })
      qc.invalidateQueries({ queryKey: ['training-enrollments'] })
    },
  })
}

export function useRejectEnrollment() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data?: ApproveRejectInput }) =>
      api.post(`/api/training-approvals/${id}/reject`, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['pending-approvals'] })
      qc.invalidateQueries({ queryKey: ['training-enrollments'] })
      // 却下で席が空くため、研修一覧・詳細の残席表示も更新する
      qc.invalidateQueries({ queryKey: ['trainings'] })
    },
  })
}

export function useProxyApprove() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data?: ProxyApproveInput }) =>
      api.post(`/api/training-approvals/${id}/proxy-approve`, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['pending-approvals'] })
      qc.invalidateQueries({ queryKey: ['training-enrollments'] })
    },
  })
}
